var render = function render(){var _vm=this,_c=_vm._self._c;return _c('is-link',{staticClass:"main_head-logo",attrs:{"is_link":Boolean(_vm.route_to_home),"href":_vm.route_to_home}},[_c('img',{attrs:{"src":_vm.img_link,"alt":"Main logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }